// Zentraler Fetch-Wrapper: meldet abgelaufene/ungültige Sitzungen per Event,
// damit App global ausloggen kann statt dass jeder Save nur generisch fehlschlägt.
export const UNAUTHORIZED_EVENT = 'crm:unauthorized';
// Sliding Renewal: Server schickt bei bald ablaufendem Token ein frisches im Header mit
export const TOKEN_RENEWED_EVENT = 'crm:token-renewed';

// Token, mit dem der Request losgeschickt wurde
function sentToken(options) {
  const h = options?.headers;
  const auth = h
    ? (typeof h.get === 'function' ? h.get('Authorization') : (h.Authorization || h.authorization))
    : null;
  return auth?.startsWith('Bearer ') ? auth.slice(7) : null;
}

// Export nativ herunterladen: kurzlebiges Token holen und den Browser die URL selbst laden
// lassen — statt fetch → Blob → Objekt-URL (11-MB-Datei im JS-Speicher, bricht auf iOS /
// in der Home-Bildschirm-App gern ab, und das sofortige revokeObjectURL konnte Safari/Firefox
// den Download wegziehen). Content-Disposition: attachment sorgt dafür, dass die Seite bleibt.
export async function downloadExport(url, authHeader) {
  const res = await apiFetch('/api/leads/export/token', { method: 'POST', headers: authHeader });
  if (!res.ok) throw new Error(`Fehler ${res.status}`);
  const { token } = await res.json();
  const a = document.createElement('a');
  a.href = `${url}${url.includes('?') ? '&' : '?'}dl=${encodeURIComponent(token)}`;
  // download-Attribut: der Browser behandelt den Klick als Download, nicht als Navigation.
  // Ohne das Attribut brach ein anschließendes history.back() (Modal schließen) die noch
  // laufende Navigation ab, bevor der Server geantwortet hatte (499 im Nginx-Log).
  a.download = '';
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  setTimeout(() => a.remove(), 2000);
}

export async function apiFetch(url, options) {
  const res = await fetch(url, options);
  // Antworten dürfen die Sitzung nur verändern, wenn sie noch zur aktiven Sitzung
  // gehören. Sonst überschreibt eine verspätete Antwort — oder ein liegengebliebener
  // Tab mit dem vorherigen Nutzer — per Renewal den frischen Login, und man sieht
  // nach dem Nutzerwechsel wieder die alten Leads.
  const sessionUnchanged = sentToken(options) === localStorage.getItem('crm_token');
  if (res.status === 401 && sessionUnchanged) {
    window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
  }
  const renewed = res.headers.get('X-Renewed-Token');
  if (renewed && sessionUnchanged) {
    localStorage.setItem('crm_token', renewed);
    window.dispatchEvent(new CustomEvent(TOKEN_RENEWED_EVENT, { detail: renewed }));
  }
  return res;
}
